export default {
  workshop: {
    breadcrumbHome: 'Accueil',
    breadcrumbSolutions: 'Solutions',
    breadcrumbCurrent: 'Atelier et artisanat',
    hero: {
      eyebrow: 'Atelier et artisanat',
      title: 'Technologie de sécurité robuste pour les environnements exigeants',
      lead: 'Poussière, humidité, variations de température : les ateliers exigent beaucoup. Nous montons des caméras à la hauteur.',
    },
    areas: {
      title: "Zones d'utilisation en atelier et artisanat",
      lead: 'De l’atelier à la cour extérieure : nous sécurisons vos outils, machines et véhicules précieux.',
      items: {
        '0': { title: "Hall d'atelier", desc: 'Les halls hauts avec machines exigent des caméras robustes à bonne résolution, même en lumière difficile.' },
        '1': { title: "Zone d'atelier", desc: 'Outils, pièces de rechange et travaux en cours : la surveillance protège votre espace et clarifie les réclamations.' },
        '2': { title: 'Zone de chargement', desc: 'Chargement et déchargement sont des occasions de vol. Les caméras documentent chaque opération de façon fiable.' },
        '3': { title: 'Zone des machines', desc: 'La production moderne exige une documentation complète des processus, même entre les machines.' },
        '4': { title: 'Cour et stationnement', desc: 'Véhicules, remorques et matériaux : la cour exige des caméras résistantes à bonne vision nocturne.' },
        '5': { title: 'Bureau et administration', desc: 'Devis, factures et données clients sont au bureau. Ici aussi, la sécurité ne doit pas être négligée.' },
      },
    },
    robust: {
      eyebrow: 'Robustesse',
      title: "Construit pour un usage intensif",
      lead: 'Les ateliers ne sont pas des showrooms. Nos caméras sont faites pour ces environnements et choisies pour vos conditions.',
      items: {
        '0': { title: 'Haute classe de protection', desc: 'Boîtiers IP66 protègent de la poussière, des projections et de la pluie, même en extérieur continu.' },
        '1': { title: 'Résistant à la température et l’humidité', desc: "De l'entrepôt glacé à l'atelier chaud : nous choisissons des caméras pour chaque plage de température." },
        '2': { title: 'Boîtiers anti-poussière', desc: 'En environnement poussiéreux, boîtiers et joints spéciaux gardent l’optique propre et nette pendant des années.' },
      },
    },
    maintenance: {
      eyebrow: 'Maintenance et suivi',
      title: 'Pour que votre système reste fiable',
      lead: 'En environnement poussiéreux et exigeant, l’entretien décide de la durée de vie. Avec SSG Care, votre système reste toujours prêt.',
      list: {
        '0': 'Contrôles réguliers de SSG Care, même hors garantie',
        '1': 'Nettoyage et inspection visuelle du boîtier et de l’objectif',
        '2': 'Mises à jour du firmware et de la sécurité selon besoin',
        '3': 'Réaction rapide en cas de panne',
        '4': 'Options de pièces de rechange et d’amélioration',
      },
      note: 'Remarque : la licéité de la vidéosurveillance dépend du cas. Nous vous conseillons, sans remplacer le conseil juridique.',
    },
    cta: {
      title: 'Votre atelier mérite un regard sûr',
      lead: 'Nous vous conseillons sans engagement sur les caméras adaptées à votre environnement et là où elles protègent le plus.',
      primary: 'Prendre rendez-vous',
      secondary: 'Découvrir SSG Care',
    },
  },
};